// Estrelas do BK Reviews nos cards de produto: o app insere .collection-star-section logo depois do
// primeiro link do card (a.product-card__link, que cobre o card inteiro), ou seja, acima da foto.
// Aqui cada bloco inserido e movido para baixo do titulo (a[ref="productTitleLink"]), acima do preco.
(function () {
  function mover(raiz) {
    raiz.querySelectorAll('.collection-star-section:not([data-hub-pos])').forEach(function (estrelas) {
      var card = estrelas.closest('product-card');
      var titulo = card && card.querySelector('a[ref="productTitleLink"]');
      if (!titulo) return;
      estrelas.setAttribute('data-hub-pos', '1');
      titulo.after(estrelas);
    });
  }
  mover(document);
  new MutationObserver(function (mudancas) {
    for (var i = 0; i < mudancas.length; i++) {
      if (mudancas[i].addedNodes.length) { mover(document); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
